module.exports = __webpack_public_path__ + "img/vodafone-white.fda12696.png";